import { tokens } from '@welbe/web-design-system';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	margin-top: 3.1rem;

	button {
		height: 36px;

		label {
			cursor: pointer;
		}
	}

	a:hover {
		color: ${tokens.color_primary_light};
	}
`;

export const LinkRecoverPassword = styled(Link)`
	color: ${tokens.color_gray_dark};
	font-size: 14px;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: flex-end;
	text-align: end;
	margin-bottom: 20px;
	gap: 10px;

	a {
		margin-top: 6px;
	}
`;

export const WrapperSignUp = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	margin-top: 16px;
	font-size: 14px;
	color: ${tokens.color_gray_dark};

	a {
		text-decoration: none;
		color: ${tokens.color_primary};
		font-weight: 600;
		cursor: pointer;
	}
`;

export const WrapperSignIn = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	width: 100%;
`;
